import styled from "styled-components";

const ImageLargeRoot = styled.div`
  height: 400px;
`;

export default ImageLargeRoot;
